/* eslint-disable */
/**
 * Visual theme for the editor/composer chrome (toolbar, borders, hint text).
 * Defaults match Hissa's current look exactly, so adopting this library is a
 * no-op visually for the first consumer — every value is overridable for
 * whoever comes next.
 */
export interface EditorTheme {
  /** Active toolbar states, brand-colored text/link swatch, table hover accents. */
  accent: string;
  /** Light background for active/selected toolbar states. */
  accentTint: string;
  /** Default control borders. */
  border: string;
  /** Dividers, menu borders. */
  borderSubtle: string;
  /** Default toolbar icon/label color. */
  text: string;
  /** Hint captions, muted labels. */
  textMuted: string;
  /** Heading color inside authored content (h2/h3, "Dark" swatch). */
  headingColor: string;
  /** Body text color inside authored content ("Body"/"Slate" swatches). */
  bodyColor: string;
}

export const DEFAULT_THEME: EditorTheme = {
  accent: "#E85936",
  accentTint: "#FDF1EE",
  border: "#DBDFE9",
  borderSubtle: "#F1F1F4",
  text: "#4B5675",
  textMuted: "#99A1B7",
  headingColor: "#111827",
  bodyColor: "#374151",
};

export function resolveTheme(theme?: Partial<EditorTheme>): EditorTheme {
  return { ...DEFAULT_THEME, ...theme };
}
